import { SignIn } from "@clerk/react";
import { Link } from "react-router-dom";

export default function SignInPage() {
  return (
    <div className="min-h-screen bg-[#FAFAFC] grid lg:grid-cols-2">
      <div className="hidden lg:flex relative items-center justify-center bg-white border-r border-slate-200 p-12">
        <div className="max-w-md">
          <Link to="/" className="flex items-center gap-2" data-testid="auth-logo-link">
            <div className="h-9 w-9 rounded-lg bg-blue-600 text-white grid place-items-center font-bold font-display">J</div>
            <span className="font-display font-bold text-lg">JRFHITS<span className="text-blue-600">.COM</span></span>
          </Link>
          <h1 className="mt-10 font-display font-extrabold text-4xl leading-tight tracking-tight text-slate-900">
            Welcome back.<br />Keep showing up.
          </h1>
          <p className="mt-5 text-slate-600 leading-relaxed">
            Sign in to continue your UGC NET or CSIR NET preparation — your progress, exposure history and dashboards are waiting.
          </p>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 lg:p-12">
        <div className="w-full flex items-center justify-center">
          <SignIn
            routing="path"
            path="/sign-in"
            signUpUrl="/sign-up"
            withSignUp
          />
        </div>
      </div>
    </div>
  );
}
